/* eslint-disable i18next/no-literal-string */
"use client";

import type { Currency } from "@mw/shared/pricing";

import { useCurrency } from "@/app/_providers/currency";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@components/core/Select";
import { CURRENCY_SYMBOLS } from "@mw/shared/pricing";
import { useTranslations } from "next-intl";

const CURRENCIES: Currency[] = ["USD", "INR"];

export function CurrencySelector({
  variant = "secondary",
  size = "md",
  buttonClassName = "",
  overlayStyle = false,
}: {
  variant?: "outline" | "outline-new" | "secondary" | "outline-inverse";
  size?: "sm" | "md" | "lg";
  buttonClassName?: string;
  overlayStyle?: boolean;
}) {
  const { currency, currencySymbol, setCurrency } = useCurrency();
  const t = useTranslations("ClientKeys.CurrencySelector");

  return (
    <Select value={currency} onValueChange={value => setCurrency(value as Currency)}>
      <SelectTrigger variant={variant} size={size} className={buttonClassName} overlayStyle={overlayStyle}>
        <SelectValue>
          {currency} ({currencySymbol})
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {CURRENCIES.map(curr => {
          const symbol = CURRENCY_SYMBOLS[curr];
          return (
            <SelectItem key={curr} value={curr} fontVariant='new'>
              {curr} ({symbol}) - {t(curr.toLowerCase() as "usd" | "inr")}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
